{
  "ChartprovideroptionsHighcharts": "Graphiques élevés",
  "ChartprovideroptionsAmcharts": "Graphiques AM",
  "NAME": "ChartProviderOptions"
}